/* 🤖 this file was generated by svg-to-ts */
export const DfIconTriangleDown16: {
  name: 'triangle-down-16';
  data: string;
} = {
  name: 'triangle-down-16',
  data: `<svg viewBox="0 0 16 16" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><path d="M8.424 11.322a.5.5 0 0 1-.848 0L3.478 4.765A.5.5 0 0 1 3.902 4h8.196a.5.5 0 0 1 .424.765l-4.098 6.557Z"/></svg>`
};
